import MinusIcon from "../icons/MinusIcon";
import AddIcon from "../icons/AddIcon";
import AddToCart from "../global/buttons/AddToCart";

const QtyAddToCart = ({
  product,
  setQty,
  qty,
  relatedProducts,
}) => {
  return (
    <div className="flex items-center gap-3">
      {(product?.stock?.qty > 0) && (
        <div className="flex items-center">
          <button
            onClick={() => setQty((prev) => prev - 1)}
            disabled={qty === 1 ? true : false}
            className="flex items-center justify-center p-2 bg-zinc-100 size-9 rounded-lg"
          >
            <MinusIcon />
          </button>
          <span className="flex items-center justify-center flex-1 w-10 sm:border-t sm:border-b h-9 sm:w-14">
            {qty}
          </span>
          <button
            onClick={() => setQty((prev) => prev + 1)}
            className="flex items-center justify-center p-2 bg-zinc-100 size-9 rounded-lg"
          >
            <AddIcon />
          </button>
        </div>
      )}
      <AddToCart
        product={product}
        qty={qty}
        fromPDP
        relatedProducts={relatedProducts}
      />
    </div>
  );
};

export default QtyAddToCart;
